import { render } from "./BaseModal.vue?vue&type=template&id=3312922d&ts=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/webeye-pro-frontend/webeye-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__